//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { LMap, LTileLayer, LMarker, LPopup, LControl, LControlZoom } from "vue2-leaflet"
import * as L from 'leaflet'
import Vue2LeafletMarkercluster from 'vue2-leaflet-markercluster';
import 'leaflet-fullscreen/dist/Leaflet.fullscreen';
require("leaflet-sidebar");

export default {
      props: ['items', 'categories', 'map_height', 'zoom', 'latitude', 'longitude', 'lang'],
      components: {
        'L': L,
        'l-control': LControl,
        'l-control-filter': LControl,
        'l-control-zoom': LControlZoom,
        'l-map': LMap,
        'v-tilelayer': LTileLayer,
        'v-marker': LMarker,
        'v-popup': LPopup,
        'v-marker-cluster': Vue2LeafletMarkercluster,
      },
      data: () => ({
        map: null,
        mapInfo:{
          zoom: 9,
          center: L.latLng(43.1862, -1.8059),
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
          clusterOptions: {},
          filterControl: null,
          infoControl: null,
        },
        filters: {
          category: [],
        },
        selectedItem: false,
        showFilter: null,
        isMobile: true,
      }),
      computed:{
        find(){
          return this.items.filter((i) => (this.filters.category.length) ? i.categories.find((e) => this.filters.category.find((z) => z == e.term_id)) : true)
        }
      },
      methods:{
        selectItem(e, id)
        {
          this.mapInfo.infoControl.show();
          this.selectedItem = this.items.find((i) => { return i.ID == id })
        },
        unSelectedItem()
        {
          this.selectedItem = false;
          this.mapInfo.infoControl.hide();
        },
        pos(lat, long)
        {
          return L.latLng(parseFloat(lat), parseFloat(long));
        },
        centerUpdated(center)
        {
          this.mapInfo.center = center
        },
        getIconByTax(id)
        {
          let cat = this.categories.find((i) => { return i.term_id == id })
          let color = (cat) ? (cat.markerColor) ? cat.markerColor : 'black' : 'black';

          return L.divIcon({
            html: '<i class="fa fa-map-marker-alt fa-3x" style="color:'+ color +'"></i>',
            iconAnchor: [15, 0],
            className: 'myDivIcon'
          })
        },
        categoryFilter(id)
        {
          let last = this.filters.category.lastIndexOf(id);
          if(last != -1)
          {
            this.filters.category.splice(last, 1);
            return;
          }

          this.filters.category.push(id)
        }
      },
      mounted(){
        this.items.forEach(item => {
          if(!item.positions.markers.length) console.error(item.post_title + " position fail.")
        });
        this.$i18n.locale = this.lang
        this.$nextTick(() => {
          this.map = this.$refs.map.mapObject;

          this.mapInfo.zoom = this.zoom;
          this.mapInfo.center = L.latLng(this.latitude, this.longitude);

          this.mapInfo.infoControl = L.control.sidebar('info-control',{
            autoPan: true,
            closeButton: false,
            position: 'right',
          }).addTo(this.map);

          if (!L.Browser.mobile)
          {
            this.isMobile = false;
            this.mapInfo.filterControl = L.control.sidebar('filter-control',{
                autoPan: true,
                closeButton: false,
                position: 'left',
            }).addTo(this.map);
            this.mapInfo.filterControl.show();
          }

          this.map.addControl(new window.L.Control.Fullscreen({
            position: 'topright'
          }));
        });

      }
  }



// WEBPACK FOOTER //
// ./scripts/vue/mapa.vue